module.exports = __webpack_public_path__ + "assets/images/5edd4399201382390fddd8aedde2defe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/kp-logo.svg
// module id = 827
// module chunks = 0